module["exports"] = [
  "#####"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/postcode.js
// module id = 784
// module chunks = 0